import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Services from '@/views/ServicesView.vue'
import About from '@/views/AboutView.vue'
import Help from '@/views/HelpView.vue'
import Blogs from '@/views/BlogsView.vue'
import Privacy from '@/views/PrivacyView.vue'

import ArticleDetail from '@/views/BlogsDetail/ArticleOne.vue'
import ArticleTwo from '@/views/BlogsDetail/ArticleTwo.vue'
import ArticleThree from '@/views/BlogsDetail/ArticleThree.vue'
import ArticleFour from '@/views/BlogsDetail/ArticleFour.vue'
import ArticleFive from '@/views/BlogsDetail/ArticleFive.vue'
import ArticleSix from '@/views/BlogsDetail/ArticleSix.vue'
import ArticleSeven from '@/views/BlogsDetail/ArticleSeven.vue'
import ArticleEight from '@/views/BlogsDetail/ArticleEight.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  { path: '/our-popular-services', component: Services },
  { path: '/about-our-services', component: About },
  { path: '/help-centre-crypto-recovery-support', component: Help },
  { path: '/blogs', component: Blogs },
  { path: '/privacy-policy-crypto-fraud', component: Privacy },
  { path: '/recovery', component: Help },
  { path: '/how-professional-crypto-recovery-firms-work-and-how-to-spot-fake-ones', component: ArticleDetail },
  { path: '/what-to-do-immediately-after-a-crypto-scam-a-step-by-step-recovery-guide', component: ArticleTwo },
  { path: '/crypto-scam-recovery-in-2026-new-threats-new-laws-and-new-hope-for-victims', component: ArticleThree },
  { path: '/tracing-usdt-bitcoin-and-ethereum-how-investigators-follow-digital-money', component: ArticleFour },
  { path: '/the-emotional-fallout-of-crypto-fraud-and-why-recovery-is-more-than-money', component: ArticleFive },
  { path: '/from-blockchain-to-courtroom-how-legal-orders-help-recover-stolen-cryptocurrency', component: ArticleSix },
  { path: '/why-most-crypto-scam-victims-fail-to-recover-funds-and-how-to-avoid-that-mistake', component: ArticleSeven },
  { path: '/pig-butchering-crypto-scams-explained-inside-the-psychology-deception-and-the-path-to-recovery', component: ArticleEight },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
